import { render } from "./PremiumLockedPage.vue?vue&type=template&id=f5c795b4&scoped=true"
import script from "./PremiumLockedPage.vue?vue&type=script&lang=js"
export * from "./PremiumLockedPage.vue?vue&type=script&lang=js"

import "./PremiumLockedPage.vue?vue&type=style&index=0&id=f5c795b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c795b4"]])

export default __exports__